<template>
  <v-card class="elevation-8">
    <v-card-title>
      <h4>{{title}}</h4>
      <slot name="header-actions"></slot>

      </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <slot name="card-content" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "quick-card",
  props: {
    title: String
  }
};
</script>

<style :scoped="true">
h4{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Quickcard.vue